// [imgur](https://api.imgur.com/models/image)
export function getLargeSizeForImgur(mediaUrl) {
  const regex = /^(https?:\/\/.*imgur\.com\/(.+)\.(png|jpg))$/;
  const match = mediaUrl.match(regex);
  if (!match || !match[2]) {
    return mediaUrl;
  }

  return mediaUrl.replace(match[2], `${match[2]}h`);
}

// [youtube](https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api)
export function getSDSizeForYoutube(id) {
  return `https://img.youtube.com/vi/${id}/sddefault.jpg`;
}



// WEBPACK FOOTER //
// ./app/utils/image.js